import { SelectValue } from 'elements/minute/sidebar/sidebarComponents/atomic/SelectValue';
import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const OIWPage = (props: Props): JSX.Element => {
    const analytics = useAnalytics();
    const ctxView = useContext(CtxView);
    const ctxModal = useContext(CtxModal);

    useEffect(() => {
        ctxView.setCustomPageConfig({
            hideLogoInList: true
        });
    }, []);

    function setVisibleMapSet(mapSetId: string) {
        ctxModal.setShowListOfStories(false);
        ctxView.setVisibleMapSetIds([mapSetId]);
        analytics.track('custom_button.clicked', {
            action: 'filter.select',
            categoryId: mapSetId
        });
    }

    const openStory = async (markerId: string) => {
        const marker = ctxView.allMarkers.find((e) => e.worldMapMarkerId === markerId);
        ctxModal.setDetailModal({
            id: marker.stories?.[0]?.storyId ?? null,
            detail: ctxView.allDetails.find((e) => e.storyId === marker.stories?.[0]?.storyId),
            markerId: null
        });
    };

    const options: {
        label: string;
        value: string;
    }[] = ctxView.allMarkers?.map((e) => ({
        label: e.stories?.[0]?.header?.title ?? '-',
        value: e.worldMapMarkerId
    }));

    return (
        <S_OIWPage className={props.className}>
            <CustomMapPage
                mapId={'5ea40ec1-ad46-44db-ba89-b8f76e79d77c'}
                highlightedStyle={''}
                hideFloors
                topOverflow={
                    <S_Flow>
                        <OverflowFilters
                            items={[
                                {
                                    text: 'Monday',
                                    onClick: () => {
                                        setVisibleMapSet('a0569d17-5dfe-4240-b850-6ef7e99d1baa');
                                    },
                                    highlighted: ctxView.visibleMapSetIds.includes(
                                        'a0569d17-5dfe-4240-b850-6ef7e99d1baa'
                                    )
                                        ? true
                                        : false
                                },
                                {
                                    text: 'Tuesday',
                                    onClick: () => {
                                        setVisibleMapSet('56f5302b-c7c7-4197-bdcd-38a9bfffb25a');
                                    },
                                    highlighted: ctxView.visibleMapSetIds.includes(
                                        '56f5302b-c7c7-4197-bdcd-38a9bfffb25a'
                                    )
                                },
                                {
                                    text: 'Wednesday',
                                    onClick: () => {
                                        setVisibleMapSet('de42c066-d96d-4bf3-8803-268185bb8abc');
                                    },
                                    highlighted: ctxView.visibleMapSetIds.includes(
                                        'de42c066-d96d-4bf3-8803-268185bb8abc'
                                    )
                                },
                                {
                                    text: 'Thursday',
                                    onClick: () => {
                                        setVisibleMapSet('1c712036-bcac-4f36-8fc0-87e2f5af5a5c');
                                    },
                                    highlighted: ctxView.visibleMapSetIds.includes(
                                        '1c712036-bcac-4f36-8fc0-87e2f5af5a5c'
                                    )
                                },
                                {
                                    text: 'Friday',
                                    onClick: () => {
                                        setVisibleMapSet('5c955e0c-5593-4361-8293-453f477ffe36');
                                    },
                                    highlighted: ctxView.visibleMapSetIds.includes(
                                        '5c955e0c-5593-4361-8293-453f477ffe36'
                                    )
                                }
                            ]}
                        />
                        <S_SelectValue
                            options={options}
                            onChange={(selected) => {
                                openStory(selected.value);
                            }}
                            placeholder="Find your place"
                            maxMenuHeight={300}
                        />
                    </S_Flow>
                }
            />
        </S_OIWPage>
    );
};

const S_OIWPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;

const S_Flow = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_SelectValue = styled(SelectValue)`
    pointer-events: all;
    width: 100%;
    max-width: 400px;
`;
